import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/admin_theme/logo-dark.png';

export default function AppHeader(props) {
	const { public_id, user, permissionsHelper } = props;

	const rightContentStyle = {
		borderLeft: '1px solid #AFAFAF',
		paddingLeft: '5px'
	};

	return (
		<header id="page-topbar">
			<div className="navbar-header">
				<div className="d-flex">
					<div className="navbar-brand-box">
						<Link
							to={
								permissionsHelper.isOnlyProctor() ? (
									`/admin/${public_id}/users`
								) : (
									`/admin/${public_id}/reports/org-stats`
								)
							}
							className="logo logo-light"
						>
							<img src={logo} alt="logo" />
						</Link>
					</div>
					<button
						type="button"
						className="btn btn-sm px-3 font-size-24 header-item waves-effect"
						id="vertical-menu-btn"
					>
						<i className="ri-menu-2-line align-middle" />
					</button>
				</div>
				<div className="right-content">
					<div className="d-inline-block content">
						<span className="content-item">
							{user.decoded_access_token.sub}
						</span>
						<span className="content-item" style={rightContentStyle}>
							<a href={props.sign_out_endpoint}>Signout</a>
						</span>
					</div>
				</div>
			</div>
		</header>
	);
}
